<template>
	<div :class="[$style.logo, $style[color]]">
		<img
			v-if="icon"
			:src="require('@/system/assets/images/logo/logo-' + color + '.webp')"
			:width="size+'px'"
			alt="GestiOS"
		>
		<div
			v-if="text"
			:class="{ 'ml-0': !icon }"
		>
			<div :class="[$style.title, $style[color]]">
				GestiOS
			</div>
			<div :class="[$style.subtitle, $style[color]]">
				Data Software
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'GLogo',
	props: {
		icon: {
			type: Boolean,
			default: true
		},
		text: {
			type: Boolean,
			default: true
		},
		dark: {
			type: Boolean,
			default: null
		},
		size: {
			type: Number,
			default: 48
		}
	},
	computed: {
		color() {
			let color = 'white';
			if (this.dark === null) {
				color = this.$settings.dark ? 'dark' : 'white';
			} else {
				color = this.dark ? 'dark' : 'white';
			}

			return color;
		}
	}
};
</script>

<style lang="scss" module>
.logo {
	display: inline-flex;
	align-items: center;
}

.title {
	font-size: 22px;
	font-weight: bold;
	text-transform: uppercase;
	line-height: 22px;
	color: $dark;
	margin-top: 2px;
}

.title.dark {
	color: $white;
}

.subtitle {
	font-size: 13px;
	opacity: 0.9;
}

.subtitle.dark {
	color: $gray-2;
}
</style>
